import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const MatchRemark = ({ props: { vo }, }) => {
    return <span>{vo.row.oldPosition || "--"}</span>;
  };
  const RenderItem = ({ props: { vo, param } }) => {
    return <span class="redText">{vo.row.oldPosition || "--"}</span>;
  };
  const Img = ({ props: { vo } }) => {
    const url = vo.row.avatar;
    return (
      <div >
        <el-image 
          style="width: 100px; height: 100px; cursor: pointer" 
          src={url} 
          fit={'contain'} 
          lazy
          preview-src-list={[url]}
        ></el-image>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "账号类别",
      prop: "unique",
      width: "100",
      render: vo => <RenderItem vo={vo} param={'unique'} />
    },
    {
      label: "用户状态",
      prop: "placeRowName",
      width: "80",
      render: vo => <RenderItem vo={vo} param={'unique'} />
    },
    {
      label: "姓名",
      prop: "unique",
      width: "100",
      render: vo => <RenderItem vo={vo} param={'unique'} />
    },
    {
      label: "性别",
      prop: "placeRowName",
      width: "80",
      render: vo => <RenderItem vo={vo} param={'unique'} />
    },
    {
      label: "头像",
      width: "120",
      render: vo => <Img vo={vo} />
    },
    {
      label: "手机号码",
      prop: "userMobile",
      width: "120"
    },
    {
      label: "出生年月",
      prop: "oldAcademyName",
      width: "150",
    },
    {
      label: "工作单位",
      prop: "oldDeptName",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "oldPosition",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "职务层次",
      prop: "oldPosition",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "任现职务层次时间",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "职级",
      prop: "oldPosition",
      width: "100",
      showOverflowTooltip: true
    },
    {
      label: "任现职级层次时间",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "任现职时间",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "管理主体",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "分管工作",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "政治面貌",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "民族",
      prop: "oldPosition",
      width: "80",
      showOverflowTooltip: true
    },
    {
      label: "最高学历",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "全日制学历",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "是否考核",
      prop: "oldPosition",
      width: "80",
      showOverflowTooltip: true
    },
    {
      label: "考核起始",
      prop: "oldPosition",
      width: "100",
      showOverflowTooltip: true
    },
    {
      label: "备注",
      prop: "matchRemark",
      width: "150",
      render: (vo) => <MatchRemark vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "操作人",
      prop: "oldPosition",
      width: "100",
      showOverflowTooltip: true
    },
    {
      label: "更新时间",
      prop: "oldPosition",
      width: "120",
      showOverflowTooltip: true
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
